/**
 * Mini SVG progress ring for a task's subtask checklist (e.g. ◔ 2/5).
 * Renders nothing when the task has no subtasks — safe to drop into
 * any meta row. Green when the checklist is complete.
 */
export function SubtaskProgressRing({ subtasks, testId }) {
  const total = subtasks?.length || 0;
  if (!total) return null;
  const done = subtasks.filter((s) => s?.completed).length;
  const r = 5.5;
  const c = 2 * Math.PI * r;
  const allDone = done === total;
  const color = allDone ? 'var(--pd-green)' : 'var(--pd-focus)';
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1 flex-shrink-0" title={`${done} of ${total} subtasks done`}>
      <svg width="14" height="14" viewBox="0 0 14 14" style={{ transform: 'rotate(-90deg)' }}>
        <circle cx="7" cy="7" r={r} fill="none" stroke="var(--pd-border)" strokeWidth="2" />
        <circle
          cx="7" cy="7" r={r} fill="none" stroke={color} strokeWidth="2"
          strokeDasharray={c} strokeDashoffset={c * (1 - done / total)} strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.3s ease' }}
        />
      </svg>
      <span className="text-[9px] tabular-nums font-semibold" style={{ color: allDone ? 'var(--pd-green)' : 'var(--pd-subtle)' }}>
        {done}/{total}
      </span>
    </span>
  );
}
